var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSyncari = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2C8FF2",
    fillRule: "evenodd",
    d: "m26.378 17.047 5.21-3.868v2.333s5.38.798 5.412 7.135c-.093 5.791-5.28 7.05-7.627 7.097-5.002-.016-7.853-3.47-8.028-6.962-.176-3.49-.14-6.345-.216-7.828-.077-1.483-1.352-3.564-3.932-3.433-2.722-.123-3.974 2.763-4.158 3.433-.124.865-.267 1.908-.267 2.81-.907 0-1.957-.006-2.922.327-.887.28-3.667 2.07-3.481 4.556s1.883 3.765 3.48 3.857c1.182.092 4.343 0 6.35 0v-2.629l4.744 4.256L16.198 32v-2.256s-4.195.016-6.348 0-6.693-1.037-6.847-7.097 5.574-7.851 6.29-8.097c.219-.683 1.663-6.564 7.904-6.55 6.587.082 7.542 5.823 7.575 6.954.031 1.076.28 7.623.288 7.693.148 1.416 1.441 3.519 4.313 3.58 2.316 0 4.17-1.52 4.261-3.715-.047-2.589-2.047-3.408-2.047-3.408v2.272l-5.21-4.329Z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSyncari);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/syncari.efd0b17a.svg";